<template>
  <section id="ranges">
    <Styles>
      <div class="ranges-form">
        <div class="columns">
          <div class="column header">
            <h4 class="form-title">Agregar rango</h4>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Número inicial">
              <b-input
                placeholder="Ingrese el número inical"
                type="text"
                name="initNum"
                v-model="initNum"
                v-validate="'required|numeric|min_value:0'"
              />
            </b-field>
            <span class="show-error">{{ errors.first("initNum") }}</span>
          </div>
          <div class="column">
            <b-field label="Número final">
              <b-input
                placeholder="Ingrese el número final"
                type="text"
                name="finalNum"
                v-model="finalNum"
                v-validate="'required|numeric|min_value:0'"
              />
            </b-field>
            <span class="show-error">{{ errors.first("finalNum") }}</span>
          </div>
          <div class="column">
            <b-field label="Descuento">
              <b-select
                placeholder="Seleccione el descuento"
                expanded
                v-model="discount"
                name="discount"
              >
                <option
                  v-for="option in discountsList"
                  :value="option.code"
                  :key="option.code"
                  :id="option.code"
                >
                  {{ option.title }}
                </option>
                <option
                  v-if="
                    Array.isArray(discountsList) && discountsList.length == 0
                  "
                  >Aún No has creado descuentos para esta empresa</option
                >
              </b-select>
            </b-field>
            <span class="show-error">{{ errors.first("discount") }}</span>
          </div>
          <div class="column mt-button">
            <vs-button
              color="primary"
              title="Agregar"
              type="filled"
              icon="check"
              @click="addRange"
            >
            </vs-button>
            <vs-button
              color="danger"
              title="Cancelar"
              type="filled"
              icon="close"
            >
            </vs-button>
          </div>
        </div>
      </div>
      <div class="ranges-discount-content" v-if="tableData.length > 0">
        <b-table :data="tableData">
          <b-table-column field="initNum " label="Rango inicial" v-slot="props">
            {{ props.row.initNum }}
          </b-table-column>
          <b-table-column field="finalNum" label="Rango final" v-slot="props">
            {{ props.row.finalNum }}
          </b-table-column>
          <b-table-column field="discount" label="Descuento" v-slot="props">
            {{ props.row.discount.title }}
          </b-table-column>
          <b-table-column field="value" label="Valor" v-slot="props">
            {{ getValue(props.row.discount) }}
          </b-table-column>
        </b-table>
      </div>
    </Styles>
  </section>
</template>

<script>
import Styles from "./styles";
import { formatPrice } from "../../../global/utils";
export default {
  name: "RangesCode",
  props: {
    discountTypes: {
      type: Array,
      default: [],
    },
    discountsList: {
      type: Array,
      default: [],
    },
  },
  components: { Styles },
  data: () => ({
    initNum: null,
    finalNum: null,
    discountType: null,
    tableData: null,
    tableData: [],
  }),
  watch: {},
  mounted() {
    console.log(this.discountTypes);
    console.log(this.discountsList);
  },
  methods: {
    getValue(item) {
      console.log(item);
      switch (item.classification) {
        case "P":
          return `${item.amount}%`;
        case "T":
        case "M":
          return `${item.amount} Minutos`;
        case "C":
          return `${formatPrice(item.amount)}`;
      }
    },
    getDiscountTypeName(discountCode) {
      const discount = this.discountTypes.find(
        (item) => item.id == discountCode
      );
      if (!discount) {
        return "No definido";
      }
      return discount.name;
    },
    getDiscountByCode(code) {
      return this.discountsList.find((item) => item.code === code);
    },
    addRange() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        const list = [...this.tableData];
        list.push({
          initNum: this.initNum,
          finalNum: this.finalNum,
          discount: this.getDiscountByCode(this.discount),
          discountType: this.discountType,
        });
        this.initNum = null;
        this.finalNum = null;
        this.discountType = null;
        this.value = null;
        this.tableData = list;
        this.addActived = false;
        this.$validator.reset();
      });
    },
  },
};
</script>
